import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../service/api';
import styles from './index.module.css';
import NavbarComponent from '../../components/Navbar/NavbarComponent';
import NavMenuComponent from '../../components/NavMenu/NavMenuComponent';
import { Row, Table, Input, Button, InputGroup, Col, InputGroupText } from 'reactstrap';
import { AiOutlineSearch, AiOutlineEye } from 'react-icons/ai';

function Empresa() {
    const [empresas, setEmpresas] = useState([]);
    const [empresasFiltradas, setEmpresasFiltradas] = useState([]);
    const [statusEmpresa, setStatusEmpresa] = useState("ativo");
    const [busca, setBusca] = useState("");

    useEffect(() => {
        api.get('empresa').then(({ data }) => {
            const dataSort = data.sort((a, b) =>
                a.nome_fantasia < b.nome_fantasia ? -1 : (a.nome_fantasia > b.nome_fantasia ? 1 : 0)
            );

            setEmpresas(dataSort);
            setEmpresasFiltradas(dataSort);
        }).catch(error => console.error("Erro ao buscar empresas:", error));
    }, []);

    useEffect(() => {
        const lowerBusca = busca.toLocaleLowerCase();
        const filtrados = empresas.filter(empresa =>
            empresa.nome_fantasia && empresa.nome_fantasia.toLocaleLowerCase().includes(lowerBusca)
        );

        setEmpresasFiltradas(busca ? filtrados : empresas);
    }, [busca, empresas]);

    return (
        <div className={styles.mainDiv}>
            <NavbarComponent />
            <NavMenuComponent />

            <div className={styles.route}>
                <Link to="/" className={styles.link}> Home </Link> &gt;
                <span> Lista de Empresas </span>
            </div>

            <div className={styles.title}>
                Lista de Empresas
            </div>

            <div className={styles.container}>
                <div className={styles.divInput}>
                    <InputGroup>
                        <Row>
                            <Col xs="6">
                                <InputGroup>
                                    <Input
                                        size="sm"
                                        placeholder="Nome"
                                        className={styles.inputBusca}
                                        type="text"
                                        value={busca}
                                        onChange={(ev) => setBusca(ev.target.value)}
                                    />

                                    <InputGroupText className={styles.textBuscar}>
                                        <AiOutlineSearch size={17} className={styles.iconBuscar} />
                                        Buscar
                                    </InputGroupText>
                                </InputGroup>
                            </Col>

                            <Col xs="6">
                                <div className={styles.selectFiltro}>
                                    <InputGroup>
                                        <Input
                                            value={statusEmpresa}
                                            onChange={(ev) => setStatusEmpresa(ev.target.value)}
                                            name="select"
                                            type="select"
                                            size="sm"
                                            className={styles.selectFiltro}
                                        >
                                            <option value="ativo">Ativo</option>
                                            <option value="inativo">Inativo</option>
                                        </Input>

                                        <InputGroupText className={styles.textFiltro}>Filtro</InputGroupText>
                                    </InputGroup>
                                </div>
                            </Col>
                        </Row>
                    </InputGroup>
                </div>

                <Table size="sm" striped className={styles.table}>
                    <thead>
                        <tr>
                            <th>Empresa</th>

                            <th>Razão Social</th>

                            <th>Ações</th>
                        </tr>
                    </thead>

                    <tbody>
                        {empresasFiltradas
                            .filter(empresa => empresa.ativo === (statusEmpresa === "ativo"))
                            .map((empresa) => (
                                <tr key={empresa.id}>
                                    <td className={styles.tbody}>{empresa.nome_fantasia}</td>

                                    <td className={styles.tbody}>{empresa.razao_social || "Empresa"}</td>

                                    <td>
                                        <Link to={`/visualizarEmpresa/${empresa.id}`}>
                                            <Button size="sm" className={styles.buttonPerfil}>
                                                <AiOutlineEye size={17} className={styles.buttonIcon} />
                                                Ver perfil
                                            </Button>
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}

export default Empresa;
